/*
* Thème: STACK
*/

$.fn.PostShare = function() {
  let self = this

  if (self.data('post-share')) {
    return self.data('post-share')
  }

  self.copy_link = function() {
    self.find('.post-share__action--copy-link').width(self.find('.post-share__action--copy-link').width())
    self.find('textarea').val(window.location.href).focus().select()
    document.execCommand("Copy")
    self.find('.post-share__action--copy-link span').text(dayalabs_l10n.COPIED_LINK)
    return false
  }

  return function() {
    self.find('.post-share__action--copy-link').on('click', self.copy_link)
    self.data('post-share', self)
    return self
  }()
}

window.PostShare_PluginInit = function() {
  $('.post-share').each(function() {
    $(this).PostShare()
  })
}

/* End: STACK */
